import { IBranch } from '@/entities/branch/model/types';
import { IOrderResponse } from '@/entities/order/model/types';
import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

interface BranchState {
  branch: IBranch | null;
  orderIds: IOrderResponse | null;
  isBranchNull: boolean;
  setBranch: (branch: IBranch) => void;
  setOrderIds: (orderIds: IOrderResponse) => void;
  setIsBranchNull: (isBranchNull: boolean) => void;
}

export const useBranchStore = create<
  BranchState,
  [['zustand/persist', BranchState]]
>(
  persist(
    (set) => ({
      branch: null,
      orderIds: null,
      isBranchNull: false,

      setBranch: (branch) => set({ branch }),
      setOrderIds: (orderIds) => set({ orderIds }),
      setIsBranchNull: (isBranchNull) => set({ isBranchNull }),
    }),
    {
      name: 'branch-storage',
      storage: createJSONStorage(() => localStorage),
    }
  )
);
